import assets from './parts/assets.js';
import commonSelect from './parts/common-select.js';
import searchFilters from './parts/search-filters.js';
import searchControlSmartform from './parts/search-control-smartform.js';
import pageLocations from './parts/page-locations.js';
import replyToOffers from './parts/reply-to-offers.js';
import MapIframeRevealer from '../../common/js/MapIframeRevealer';
import setCookieTabs from './parts/search-ai-cookie.js';
import recaptchaLoad from './parts/recaptcha-load.js';
import offerDetailInList from '../../../shared/js/parts/offer-detail-in-list.js';
import commonOffers from '../../../shared/js/helpers/commonOffers';

export default function () {
	assets();
	commonSelect();
	searchFilters();
	pageLocations();
	replyToOffers();
	searchControlSmartform();
	setCookieTabs();
	MapIframeRevealer();
	offerDetailInList();
	commonOffers();
	recaptchaLoad();
}
